import React from 'react'
import EmployeeTableRow from './EmployeeTableRow'

export default function EmployeeTable({
  employeeData,
  paginatedData,
  sortOrder,
  handleSort,
  selectedEmployeeIds,
  selectedCheckboxId,
  activeId,
  handleCheckboxChange,
  moveToEmployeeDetails,
  handleShowLeaveLogButton,
  handleShowLeaveLog,
  setEmployeeInformationId,
  loadingGif,
}) {
  return (
     <table>
        <thead>
          <tr>
            <th></th>
            <th>SL No.</th>
            <th onClick={() => handleSort("employee_id")}>
              Employee ID {sortOrder["employee_id"] === "asc" ? "↑" : "↓"}
            </th>

            <th colSpan="2" onClick={() => handleSort("employee_full_name")}>
              Full Name {sortOrder["employee_full_name"] === "asc" ? "↑" : "↓"}
            </th>
            <th onClick={() => handleSort("personal_phone_number")}>
              Phone Number{" "}
              {sortOrder["personal_phone_number"] === "asc" ? "↑" : "↓"}
            </th>
            <th onClick={() => handleSort("official_email")}>
              Email {sortOrder["official_email"] === "asc" ? "↑" : "↓"}
            </th>
            <th onClick={() => handleSort("updated_at")}>
              Last Updated{" "}
              {sortOrder["personal_phone_number"] === "asc" ? "↑" : "↓"}
            </th>
            <th colSpan={2} onClick={() => handleSort("is_active")}>
              Status {sortOrder["is_active"] === "asc" ? "↑" : "↓"}
            </th>
          </tr>
        </thead>

        <tbody>
          {employeeData.length > 0 ? (
            paginatedData?.map((user) => (
              <EmployeeTableRow
                key={user.employee_information_id}
                user={user}
                selectedEmployeeIds={selectedEmployeeIds}
                selectedCheckboxId={selectedCheckboxId}
                activeId={activeId}
                handleCheckboxChange={handleCheckboxChange}
                moveToEmployeeDetails={moveToEmployeeDetails}
                handleShowLeaveLogButton={handleShowLeaveLogButton}
                handleShowLeaveLog={handleShowLeaveLog}
                setEmployeeInformationId={setEmployeeInformationId}
              />
            ))
          ) : (
            <tr>
              <td colSpan="9">
                <img src={loadingGif} alt="Loading" className="w-12.5 h-12.5" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
  )
}
